export default __webpack_public_path__ + "static/media/import.ab34af7c.gif";